export default {
  nflDraftEligible: "nfl draft eligible",
  not: "not",
  philter: "athlete-profile-player"
};
